<template>
  <div>
    <v-container id="paramsGenerator">
      <v-card max-width="800px">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-select
            v-model="selectedModule"
            :items="moduleList"
            item-text="name"
            item-value="id"
            label="Learning Module"
            outlined
            return-object
          />

          <!-- Dropdown with language options -->
          <v-select
            v-model="locale"
            :items="locales"
            item-text="name"
            item-value="code"
            label="Preferred Language"
            outlined
          />
          
          <v-text-field
          v-model="redirectURL"
          label="Redirect URL"
          outlined
          />

          <!-- Show a read only text area that contains a computed field called customParams -->
          <v-textarea
            readonly
            :value="customParams"
            label="Custom Params"
            outlined
            hint="Copy and paste this into your LMS under custom parameters"
            persistent-hint
          />
          <!-- add a button that copies customParams to the clipboard -->
          <v-btn
            color="blue darken-1"
            @click="copyToClipboard"
          >
            {{ $t('integrations.label.copyToClipboard') }}
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="cancel">
            {{ $t('global.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import { ContentLibrary } from '@/helpers/contentLibrary.js'
  import { getSupportedLocales } from '@/util/i18n/supported-locales'

  export default {
    name: 'ParamsGenerator',
  

    data () {
      return {
        selectedModule: null,
        locale: 'en',
        redirectURL: '',
        modules: [],
      }
    },

    computed: {
      moduleList () {
        const list = this.modules.map((module) => {
          return {
            id: module.id,
            name: module.locales[this.$i18n.locale].title,
          }
        })
        return list
      },
      title () {
        return this.$t('integrations.label.paramsGenerator')
      },
      locales () {
        return getSupportedLocales()
      },
      customParams () {
        return `
module=${this.selectedModule?.id ?? ''}
lang=${this.locale ?? ''}
redirect=${this.redirectURL ?? ''}
`
      },
    },

    async mounted () {
      // We need the content library for this user
      const contents = await ContentLibrary.Get(this.$store, this.$i18n)
      // need to remove content that is not visible to this user, this is done by filtering by the purchased field
      this.modules = contents === null ? [] : contents.filter((x) => { 
        return x.purchased && [ContentLibrary.ContentType.MODULE, ContentLibrary.ContentType.SIMULATOR].includes(x.type)
      })
    },

    methods: {
      copyToClipboard () {
        navigator.clipboard.writeText(this.customParams)
      },
      cancel () {
        this.$emit('cancel')
      },
    },
  }
</script>

<style>
</style>

